import React, { Component, useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { BrowserRouter, Route, Link } from "react-router-dom";
import useFetch from '../../../../commons/useFetch'


function SlideMap() {
  const { data: specialties } = useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/specialties/');
  const { data: destinations } = useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/destinations/');
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 900,
    centerMode: true,
    variableWidth: true,
    prevArrow: (
      <div>
        <img src="/images/ic_prev.png" />
      </div>
    ),
    nextArrow: (
      <div>
        <img src="/images/ic_next.png" />
      </div>
    ),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          centerMode: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          centerMode: true,
          slidesToShow:4,
        },
      },
    ],
  };
  
  return (
    <div className="slideMap styleArrow">
      <Slider {...settings}>
        {specialties.map((content) => {
          return (
            <div className="item">
              <div className="itemBox">
                <img className="img-fluid" src={content.image} alt="" />
                <div className="contentItem">
                  <BrowserRouter>
                    <Link to={`/destination/${content.id}`}>{content.name}</Link>
                  </BrowserRouter>
                  <p>{}</p>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}
export default SlideMap;
